// Filters the sidebar navigation by a typed query so a page can be found by
// name instead of by opening sections one at a time. A plain module (no JSX)
// so the suite can exercise the behaviour directly.
//
// An item matches on a case-insensitive substring of its label. A query that
// matches a section's title keeps the whole section, so typing "finance"
// surfaces every Finance page. Sections left with no items are dropped.
//
// A section item may be a group (My Info) rather than a page, in which case it
// carries `children`. A group's own name stands for everything under it, the
// same way a section title does — without that, typing "my info" would find
// nothing at all, because My Info is a group and no longer a page. Otherwise
// the group is kept with only its matching pages, and dropped when none match.
export function filterNavSections(sections, query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return sections;
  const hit = (s) => String(s || '').toLowerCase().includes(q);
  return sections
    .map(section => {
      if (hit(section.section)) return section;
      const items = [];
      for (const item of section.items) {
        if (item.children) {
          if (hit(item.label)) { items.push(item); continue; }
          const children = item.children.filter(c => hit(c.label));
          if (children.length) items.push({ ...item, children });
        } else if (hit(item.label)) {
          items.push(item);
        }
      }
      return { ...section, items };
    })
    .filter(section => section.items.length > 0);
}
